/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingConcernedOwnershipDto } from './buildingConcernedOwnershipDto.model';
import { ParcelSearchItem } from './parcelSearchItem.model';


/**
 * Building list item - condensed building information for list views and search results
 */
export interface BuildingListItemDto { 
    /**
     * Cadastral building identifier (BUD_ID) used across all versions
     */
    budId?: number;
    /**
     * Administrative district name
     */
    caobceNazev?: string;
    /**
     * List of concerned ownerships - ownership relationships related to this building
     */
    concernedOwnerships?: Array<BuildingConcernedOwnershipDto>;
    /**
     * Count of parcels associated with the building that are not the identifying parcel
     */
    countParcelWithoutIdentParcel?: number;
    /**
     * User-defined building name (Název budovy, max 64 chars), shared across all building versions
     */
    customName?: string | null;
    /**
     * Unique internal building version identifier
     */
    id?: number;
    /**
     * Identifying parcel (identifikační parcela) - the parcel on which the building stands
     */
    identParcel?: ParcelSearchItem;
    /**
     * Cadastral area name
     */
    katuzeNazev?: string;
    /**
     * Region name (kraj)
     */
    krajNazev?: string;
    /**
     * Land registry folio number (list vlastnictví)
     */
    lv?: number;
    /**
     * Cadastral building label computed from the cadastral data (e.g. \'č.p. 123\', \'č.e. 45\' or the building type)
     */
    name?: string;
    /**
     * Municipality name (obec)
     */
    obecNazev?: string;
    /**
     * District name (okres)
     */
    okresNazev?: string;
    /**
     * Building type code from cadastral registry (TYPBUD_KOD)
     */
    typbudKod?: number;
    /**
     * Building type name (e.g., \'budova s číslem popisným\', \'budova bez čísla popisného nebo evidenčního\')
     */
    typbudNazev?: string;
    /**
     * Building structure code (ZPVYBU_KOD) - construction type classification
     */
    zpvybuKod?: number;
    /**
     * Building structure name (e.g., \'rodinný dům\', \'zemědělská usedlost\')
     */
    zpvybuNazev?: string;
}

